import React, { useContext } from 'react'
import styles from './meta-header.module.scss'
import ApiContext from '../utils/api-context'
import Image from 'next/image'

const MetaHeader = (props) => {
  return (
    <div className={`meta-header ${props.dark ? 'dark' : ''}`}>
      {props.metaData.heroImage && (
        <Image
          src={`${props.metaData.heroImage.url}`}
          alt={props.metaData.heroImage.alternativeText}
          layout={'fill'}
        />
      )}
      {props.metaData.pageTitle && <h1>{props.metaData.pageTitle}</h1>}
      {props.metaData.pageIntro && (
        <div dangerouslySetInnerHTML={{ __html: props.metaData.pageIntro }} />
      )}
    </div>
  )
}
export default MetaHeader
